import i18n from '@/i18n'
import { formatMoney } from '@/utils/NumericMutations'
import {
  PayOn, PayBy, AccountingCategory, ActivityStatus,
  CostType, RuntimeCounterparty, RecoveryType
} from '@/utils/Enumerations.js'

export function recoveryRateText (rate, type) {
  switch (type) {
    case RecoveryType.PercentageOfPayable.value:
      return `${rate}%`
    case RecoveryType.RatePerTon.value:
      return `${formatMoney(rate)}/t`
    case RecoveryType.RatePerMBF.value:
      return `${formatMoney(rate)}/MBF`
    default:
      return formatMoney(rate)
  }
}

export function recoveryTypeAllowedForPayBy (recoveryType, payBy) {
  return recoveryType !== RecoveryType.RatePerMBF.value || payBy === PayBy.Volume.value
}

export function costBehaviorFromInt (x) {
  return CostType.fromInt(x)
}

export function payByFromInt (val) {
  return PayBy.fromInt(val)
}

export function payOnFromInt (val) {
  return PayOn.fromInt(val)
}

export function activityStatusFromInt (val) {
  return ActivityStatus.fromInt(val)
}

export function costTypeFromInt (val) {
  return CostType.fromInt(val)
}

export function runtimeCounterparty (val) {
  return RuntimeCounterparty.fromInt(val)
}

export function categoryFromInt (val) {
  switch (val) {
    case AccountingCategory.Payable.value:
      return { label: i18n.t('ap'), tooltip: i18n.t('accountsPayable') }
    case AccountingCategory.Receivable.value:
      return { label: i18n.t('ar'), tooltip: i18n.t('accountsReceivable') }
    case AccountingCategory.Accrual.value:
      return { label: i18n.t('accr'), tooltip: i18n.t('accruals') }
  }
}

export function costTypeIconFromInt (costType) {
  switch (costType) {
    case CostType.Unspecified.value:
      return 'mdi-alpha-u-circle-outline'
    case CostType.Production.value:
      return 'mdi-alpha-p-circle-outline'
    case CostType.Stumpage.value:
      return 'mdi-alpha-s-circle-outline'
    case CostType.NonInventory.value:
      return 'mdi-alpha-n-circle-outline'
  }
}
